<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">   
      
      <el-form ref="update" :model="update" label-width="100px" size="small">
      	  <div class="backborder3">
      	  	  <el-col :span="23">
      	  	  	  <el-col :span="8">
		              <el-form-item label="广告名称">
		                  <el-input v-model="update.name" placeholder="请输入广告名称" style="width:90%"></el-input>
		              </el-form-item>
	              </el-col>
	              <el-col :span="10">
      	  	  	  	  <el-form-item label="广告时间">
	              	  	  <el-date-picker v-model="update.date" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" :unlink-panels="false" style="width:90%"></el-date-picker> 
	              	  </el-form-item>
	              </el-col>
              </el-col>
      	  </div>
      	  <div class="backborder3" style="margin-top:10px">
      	  	  <el-col :span="23">
      	  	  	  <el-col :span="8">
		              <el-form-item label="广告位置">
		                  <el-select v-model="update.pid" clearable filterable placeholder="请选择广告位置" style="width:70%">
			              	  <el-option v-for="(item,index) in plists" :label="item.name" :value="item.id" :key="index"></el-option>
			              </el-select>
						  <el-tooltip class="item" effect="dark" content="辅助选择广告位" placement="top">
						  	  <el-button type="warning" icon="el-icon-search" circle size="mini" @click="getlocationpt"></el-button>
						  </el-tooltip>
		              </el-form-item>
	              </el-col>
	              <el-col :span="8">
		              <el-form-item label="跳转类型">
		                  <el-select v-model="update.type" clearable filterable placeholder="请选择跳转类型" style="width:70%">
			              	  <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
			              </el-select>
	              	  </el-form-item>
	              </el-col>
				  <el-col :span="8">
		              <el-form-item label="排序">
		                  <el-input v-model="update.sort" placeholder="请输入排序" style="width:50%"></el-input>
	              	  </el-form-item>
	              </el-col>
              </el-col>
      	  </div>
      	  <div class="backborder3" style="margin-top:10px" v-if="update.type > 1">
      	  	  <el-col :span="23">
	              <el-col :span="8" v-if="update.type=='2'">
		              <el-form-item label="跳转链接">
		                  <el-input v-model="update.url" placeholder="请输入跳转链接" style="width:90%"></el-input>
		              </el-form-item>
	              </el-col>
	              <el-col :span="8" v-if="update.type=='3'">
		              <el-form-item label="跳转条件">
		                  <el-select v-model="update.brandid" clearable filterable placeholder="请选择品牌" style="width:30%">
			              	  <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
			              </el-select>
			              <el-cascader :options="categorylist" v-model="update.catid" clearable placeholder="请选择分类" change-on-select style="width:30%"></el-cascader>
		              	  <el-select v-model="update.pettype" clearable filterable placeholder="请选择品类" style="width:30%">
			              	  <el-option v-for="(item,index) in pettypelists" :label="item.name" :value="item.id" :key="index"></el-option>
			              </el-select>
		              </el-form-item>
	              </el-col>
	              <el-col :span="8" v-if="update.type=='4'">
		              <el-form-item label="跳转商品">
		                  <el-button type="primary" size="small" icon="el-icon-search" @click="addgoods('update')">选择商品</el-button>
		                  <el-col :span="23">
		                      <span style="color:#F56C6C">跳转至商品：{{update.goods.name}}</span>
		                  </el-col>
		              </el-form-item>
	              </el-col>
				  <el-col :span="23" v-if="update.type=='11'">
				  	  <!--
				  	  <el-form-item label-width="200" label="跳转至品牌促销活动">
				  	 	  <el-select v-model="update.activeid" size="small" clearable filterable placeholder="请选择活动" style="width:50%">
			              	  <el-option v-for="(item,index) in brandactiveinfos" :label="item.name" :value="item.id" :key="index"></el-option>
			          	  </el-select>
					  </el-form-item>
					  -->
					  <el-form-item label="活动品牌">
					  <el-select v-model="update.brandid" clearable filterable placeholder="请选择品牌" width="120">
			              <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
			          </el-select>
					  </el-form-item>
				  </el-col>      	  	  	  
              </el-col>
      	  </div>
      	  
      	  <div class="backborder3" style="margin-top:10px">
      	  	  <el-col :span="23">
      	  	  	  <el-col :span="10">
					  <!--
	              	  <el-form-item label="上传图片">
	              	  	  <el-tag type="danger">温馨提示：建议上传188px * 64px的图片，图片的大小不超过200k</el-tag>
	              	  </el-form-item>
					  -->
	              	  <el-form-item>
	              	  	  <input @change="filecreateminiChange($event,'update')" type="file" id="upload_file">
	              	  	  <img :src="update.showthumb" v-if="update.thumb!='' && update.thumb!=null" style="width:90%">
	              	  	  <img src="../../assets/default_img.png" style="width:70%" v-if="update.thumb=='' || update.thumb==null">
	              	  </el-form-item>
	              </el-col>
      	  	  </el-col>
      	  	  <el-col :span="24" style="margin-top:10px;text-align:right;padding-bottom:3%">
      	  	  	  <el-button size="small" type="primary" :loading="updateadLoading" @click="updateadSave">保 存</el-button>
      	  	  </el-col>
      	  </div>
      </el-form>
      	  	 
          
          <!-----------  选择商品信息  ------------>
	      <el-dialog title="选择商品信息" :visible.sync="goodsDialog" width="55%" top="5vh">
	      	  <el-form :inline="true" class="demo-form-inline" size="small">
	      	  	  <el-form-item style="width:20%">
		              <el-select v-model="goodsquery.brandid" placeholder="请选择品牌" @change="goodsisnewselect=true" filterable clearable>
		              	  <el-option v-for="(item,index) in brandlists" :label="item.name" :value="item.id" :key="index"></el-option>
		              </el-select>
		          </el-form-item>
	      	  	  <el-form-item style="width:20%">
	      	  	  	  <el-cascader :options="categorylist" v-model="goodsquery.catid" clearable placeholder="请选择分类" change-on-select @change="goodsisnewselect=true"></el-cascader>
		          </el-form-item>
		          <el-form-item style="width:25%">
		              <el-input placeholder="请输入关键字" v-model="goodsquery.key" @keyup.enter.native="getgoodslists"  @change="isnewselect=true"  clearable></el-input>
		          </el-form-item>
		          <el-form-item>
		              <el-button type="primary" icon="el-icon-search" @click="getgoodslists">查询</el-button>
		          </el-form-item>
	      	  </el-form>
	      	  <el-table :data="goodlists" v-loading="goodsLoading">    	  
	      	  	  <el-table-column prop="name" label="商品名称"></el-table-column>         
		          <el-table-column label="操作" align="center" width="90">
			          <template slot-scope="scope">
			              <el-button type="success" size="mini" icon="el-icon-check" circle @click="ensureCurrent(scope.row)"></el-button>
			          </template>
		          </el-table-column>
	      	  </el-table>
		      <div class="block">
		          <!--分页begin-->
		          <el-pagination
		              @size-change="goodspageSizeChange"
		              @current-change="goodspageCurrentChange"
		              :current-page="goodslits_total_rows.p"
		              :page-sizes="[10, 20, 50]"
		              :page-size="goodslits_total_rows.rollpage"
		              layout="total, sizes, prev, pager, next, jumper"
		              :total="goodslits_total_rows">
		          </el-pagination>
		          <!--分页end-->
		      </div>
	      </el-dialog>

		  <!-- 辅助选取广告位信息 -->
		  <el-dialog title="获取广告位置信息" :visible.sync="plistsDialog" width="45%" top="5vh">
		  	  <div class="pt-info-msg">
				  <ul>
				  	  <li v-for="(item,index) in plists" :key="index" @click="selectptid(item,index)">
						<span>{{item.name}}</span>
						<a><img :src="GLOBAL.staticUrl+item.thumb" style="float:left;width:100%"/></a>
						<h v-if="item.isselect==false"></h>
					  </li>
				  </ul>
			  </div>
			  <div slot="footer" class="dialog-footer">
              	  <el-button size="medium" @click="plistsDialog = false">取 消</el-button>
          	  </div>
		  </el-dialog>
          	 
  </div>
  </transition>  
</template>

<script>

export default {
  props:['childdata'],
  data () {
    return {
        url:this.GLOBAL.domain+"Ad/index",
        transitionshow:true,
        actionauth:'', //功能权限
        update: {
        	act:'edit',
        	token:this.$cookies.get('token'),
        	id:'',
        	name:'',
        	pid:'',
			activeid:'',
        	brandid:'',
        	catid:[],
        	date:[],
        	type:'1',
        	pettype:'',
        	url:'',
        	thumb:'',
        	showthumb:'',
			sort:'',
        	goods:[]
        },
        plists:[],
        typelists:[
        	{id:'1',name:'不做跳转'},
        	{id:'2',name:'跳转链接'},
        	{id:'3',name:'跳转条件'},
        	{id:'4',name:'跳转商品'},	
			{id:'7',name:'跳转至新人活动商品列表'},
			{id:'8',name:'跳转至新品专区列表'},
			{id:'9',name:'跳转至特卖活动专区列表'},
			{id:'10',name:'跳转至秒杀活动专区列表'},
			{id:'11',name:'跳转至品牌促销活动'},
			{id:'12',name:'跳转至换购活动专区'},
			{id:'13',name:'跳转至领取优惠券'},
			//{id:'14',name:'跳转至选品-分类'}
			{id:'15',name:'团购（集采）专区'},
			{id:'16',name:'一件代发'},
			{id:'17',name:'极速达'},
			{id:'18',name:'跳转至邀请有礼'},
        ],
        pettypelists:[
        	{id:'1',name:'狗狗'},
        	{id:'2',name:'猫猫'},
        	{id:'4',name:'猫狗通用'},
        	{id:'3',name:'小宠'},
        	{id:'9',name:'其它'},
        ],
        brandlists:[],
        categorylist:[],
        createadLoading:false,
        goodsquery: {
        	act:'getgoodslists',
        	token:this.$cookies.get('token'),
        	catid:'',
        	brandid:'',
        	key:'',
        	p:1,
        	rollpage:10
        },
        addtype:'',
        goodsDialog:false,
        goodsbrandLoading:false,
        goodsisnewselect:false,
        pclickstatus:[],
        multipleSelection:[],
        goodlists:[],
        goodslits_total_rows:0,
        updateadLoading:false,
		brandactiveinfos:[],
		plistsDialog:false,
      
    }
  },
    
  mounted(){  
      this.getactionauth();
      this.getposition(); //获取广告位置信息
      this.getBrand(); //获取品牌信息
      this.getCategoryList(); //获取商品分类信息
      this.editCurrent(); //获取广告信息
	  this.getbrandactiveinfos(); //获取商品促销活动信息
  },
  
  methods:{
    
      //获取功能权限
      getactionauth() {
    	  var data =this.$cookies.get('actionauth');
    	  data=JSON.parse(data);
          this.actionauth=data;
      },
      
      editCurrent() {
      	  var item=this.childdata;
      	  this.update.id=item.id;
          this.update.name='';
          this.update.pid='';
		  this.update.activeid="";
          this.update.brandid='';
          this.update.catid=[];
          this.update.date=[];
          this.update.type='1';
          this.update.pettype='';
          this.update.url='';
          this.update.thumb='';
          this.update.showthumb='';
		  this.update.sort='';
          this.update.goods=[];
		
		  var resource = this.$resource(this.url);
          resource.save({act:'getinfos',token:this.$cookies.get('token'),id:item.id}).then((res) => {
	          if(res.data.Result>0){
	              if(res.data.Result=='70001') this.$router.push('/login')
	              this.$message.error(res.data.Message);
	          }else{
	        	  var result = JSON.parse(Base64.decode(res.data.Data));
	        	  this.update.name=result.name;
		          this.update.pid=result.pid;
				  this.update.activeid=result.activeid;
		          this.update.brandid=result.brandid;
		          this.update.catid=result.catid;
		          this.update.date=result.date;
		          this.update.type=''+result.type+'';
		          this.update.pettype=result.pettype;
		          this.update.url=result.url;
		          this.update.thumb=result.thumb;
		          this.update.showthumb=this.GLOBAL.staticUrl+result.thumb;
		          this.update.goods=result.goods;
				  this.update.sort=result.sort;
	          }
          }).catch((res) => {
            
          }); 
      },
      
      
      /** 获取广告位信息 **/
      getposition() {
    	var resource = this.$resource(this.url);
        resource.query({act:'plists',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.plists = JSON.parse(Base64.decode(res.data.Data));
				this.plists.forEach(function(item,i) {
					item.isselect=false;
				});
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
      },
      
      /** 获取品牌 **/
      getBrand(){
        var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
        resource.query({act:'getsyslists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.brandlists = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
        });
      },
      
      /** 获取产品分类 **/
      getCategoryList() {
    	var resource = this.$resource(this.GLOBAL.domain+"Product/index");
        resource.query({ act:'getmallcatelist',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.categorylist = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
      },
      
      addgoods(type) {
    	//重置搜索商品信息
    	this.goodsquery.catid=[];
        this.goodsquery.brandid='';
        this.goodsquery.key='';
        this.goodsquery.p=1;
        this.goodsquery.rollpage=10;
    
    	this.addtype=type;
    	this.goodsDialog=true;
    	this.getgoodslists();
    },
    
    /** 获取商品信息 **/
    getgoodslists() {
    	if(this.goodsisnewselect==true) {
    		this.goodsquery.p=1;
    		this.goodsquery.rollpage=10;
    	}
        
    	this.goodsbrandLoading=true;
    	this.pclickstatus=[]; //重新设置商品/品牌状态
    	this.multipleSelection=[]; //重新设置已选中的商品/品牌
        var resource = this.$resource(this.url);
        resource.save(this.goodsquery).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.goodsbrandLoading=false;
	        }else{
	        	var _this=this;
	            this.goodlists = JSON.parse(Base64.decode(res.data.Data));
	            this.goodslits_total_rows=parseInt(res.data.count);
	            //设置单行信息状态为未选择
	            this.goodlists.forEach(function(e,index) {_this.pclickstatus[index]=0;});
	            this.goodsbrandLoading=false;
	            if(this.goodsisnewselect==true) this.goodsisnewselect=false;
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.goodsbrandLoading=false;
        });
    },
    
    goodspageSizeChange(val) {
        this.goodsquery.rollpage = val;
        this.getgoodslists();
    },
    goodspageCurrentChange(val) {
        this.goodsquery.p = val;
        this.getgoodslists();
    },
    
    /** 选中需要选择的商品信息 **/
    ensureCurrent(item) {
    	if(this.addtype=='create') {
    		this.create.goods=[];
    		this.create.goods.push({id:item.id,name:item.name});
    	}else {
    		this.update.goods=[];
    		this.update.goods.push({id:item.id,name:item.name});
    	}
    	this.goodsDialog=false;
    },
    
    /** 上传广告图片 **/
    filecreateminiChange(el,type) {
    	var resource = this.$resource(this.GLOBAL.uploadUrl);
    	var formData = new FormData();
    	formData.append('file', el.target.files[0]);
		formData.append('sys_type', 'cz');
		formData.append('intranet_token', 'Tzx9VY0OOGjUYZRb');
    	resource.save(formData).then((res) => {
	    	var data=JSON.parse(Base64.decode(res.body.Data));
	        if(data.Result > 0) {
	            this.$message.error(data.msg);
	        }else {
	        	if(type=='create') {
	        		this.create.showthumb=this.GLOBAL.staticUrl+data.imgsrc;
	            	this.create.thumb=data.imgsrc;
	        	}else {
	        		this.update.showthumb=this.GLOBAL.staticUrl+data.imgsrc;
	            	this.update.thumb=data.imgsrc;
	        	}
			    el.target.value = '';  
	        }
	     }).catch((res) => {
	        	
	     });
    },
    
    /** 更新广告信息 **/
    updateadSave() {
    	this.updateadLoading=true;  
	    var resource = this.$resource(this.url);
        resource.save(this.update).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	            this.updateadLoading=false;  
	        }else{
	        	this.$message.success("更新广告成功！");
	        	this.updateadLoading=false; 
	        	this.$emit('closechild','Adedit'); //关闭窗口
	        }
        }).catch((res) => {
            //this.$message.error(this.GLOBAL.errortext);
            this.updateadLoading=false; 
        }); 
    },

	/** 选中模板 **/
	selectptid(item,index) {
		this.plists.forEach(function(t,i) {
			i==index ? t.isselect=true : t.isselect=false;
		});
		this.create.pid=item.id;
		this.plistsDialog=false;
	},
    
    /** 获取促销活动信息 **/
	getbrandactiveinfos() {
		var resource = this.$resource(this.url);
        resource.query({ act:'getbrandactiveinfos',token:this.$cookies.get('token')}).then((res) => {
	        if(res.data.Result>0){
	            if(res.data.Result=='70001') this.$router.push('/login')
	            this.$message.error(res.data.Message);
	        }else{
	            this.brandactiveinfos = JSON.parse(Base64.decode(res.data.Data));
	        }
        }).catch((res) => {
            this.$message.error(this.GLOBAL.errortext);
        });
	},
    
	/** 获取广告位信息 **/
    getlocationpt() {
		let _this=this;
		this.plistsDialog=true;
		this.plists.forEach(function(item,i) {
			_this.update.pid==item.id ? item.isselect=1 : item.isselect=0;
		});
	},

	/** 选中模板 **/
	selectptid(item,index) {
		this.plists.forEach(function(t,i) {
			i==index ? t.isselect=true : t.isselect=false;
		});
		this.update.pid=item.id;
		this.plistsDialog=false;
	},
    

   } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder3 {background:#fff;border-radius:15px;border:1px solid #ddd;float:left;width:98%;padding:1% 1% 0 1%;}
.pt-info-msg {float:left;width:100%;padding:10px;}
.pt-info-msg ul {padding:0;margin:0}
.pt-info-msg li {float:left;margin-bottom:20px;list-style:none;border:1px solid #dddddd;border-radius:5px;background:rgb(221,221,221,.3)}
.pt-info-msg li:nth-child(odd) {width:46%;margin-right:3%}
.pt-info-msg li:nth-child(even) {width:46%;}
.pt-info-msg li a {float:left;width:100%;height:305px;overflow:hidden;cursor:pointer}
.pt-info-msg li a img {float:left;width:100%}
.pt-info-msg li span{float:left;width:100%;padding:10px;text-align:center}
.pt-info-msg li h {position:relative;float:left;width:100%;height:355px;background:rgb(0,0,0,.8);margin-top:-355px;border-radius:5px}
.pt-info-msg li h:hover {transition:all .5s;background:rgb(0,0,0,0);cursor:pointer}
</style>


// WEBPACK FOOTER //
// src/components/mall/Adedit.vue